import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
   name: 'customCurrency',
   standalone: true,
})
export class CustomCurrencyPipe implements PipeTransform {
   transform(value: number): string {
      const formattedValue = value?.toLocaleString('pt-BR', {
         style: 'currency',
         currency: 'BRL',
         minimumFractionDigits: 2,
         maximumFractionDigits: 2,
      });
      return formattedValue;
   }
}
